import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Dossier } from "src/app/suivi-portefeuille/core/model/dossier";
import { DossierService } from "src/app/suivi-portefeuille/core/service/dossier.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { DossierProvision } from "src/app/suivi-portefeuille/core/model/DossierProvision";
import { ProvisionOutput } from "src/app/suivi-portefeuille/core/model/ProvisionOutput";
import { GarantieModel } from "src/app/core/models/garantie-model";

@Component({
  selector: "app-provision-tab",
  templateUrl: "./provision-tab.component.html",
  styleUrls: ["./provision-tab.component.scss"],
})
export class ProvisionTabComponent implements OnInit {
  dossier: Dossier;
  requestEncours: Request;
  provisionOutput: ProvisionOutput = new ProvisionOutput();
  dossierProvision: DossierProvision = new DossierProvision();
  garanties: GarantieModel[];
  numDossier: number;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private _dossierService: DossierService,
    private _requestService: RequestService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.numDossier = params["numDossier"];
      this.getDossierByNumDossier(this.numDossier);
      this.getDossierProvision(this.numDossier);
    });
  }

  getDossierByNumDossier(numDossier) {
    this._dossierService
      .getDossierByNumDossier(numDossier)
      .subscribe((data) => {
        this.dossier = data;
      });
  }

  getDossierProvision(numDossier) {
    this._dossierService.getDossierProvision(numDossier).subscribe((data) => {
      if (data) {
        this.dossierProvision = data;
        console.log(this.dossierProvision, "yyy");
      
        if (data.garanties) {
          this.garanties = data.garanties;
        }
      }
    });
  }
}
